import { createClient } from "@connectrpc/connect";
import { SourceService } from "@reliquo/proto/source/connect";
import { createTransport } from "./transport";

/**
 * Returns a typed ConnectRPC SourceService client with the given access token
 * injected as a Bearer header.
 */
export function getSourceClient(accessToken: string | null) {
  return createClient(SourceService, createTransport(accessToken));
}
